import { CustomValidationLogic } from "../models/MultiAutocomplete.types";

export const minLengthSimpleValidation: CustomValidationLogic = (value: string, { minLength }) => {
  if (value.length > 0 && value.length < minLength) {
    return ` Ingrese al menos ${minLength} caracteres`;
  }
};
